import React, { ChangeEvent, FC, ReactNode, useState } from 'react';
import { Button, Input, Select } from 'antd';
import { Check, Close, Control, Search } from 'common/svg';
import { ItemsNotFound } from 'common/components/Text/ItemsNotFound';
import { filterSelectorOptions } from 'common/helpers/filters.helper';
import { IOption } from 'common/models/commonModel';

interface IComponentProps {
  suffix?: ReactNode;
  placeholder?: ReactNode;
  searchable?: boolean;
  allowClear?: boolean;
  options: IOption[];
  value?: string | number;
  onChange?: (value?: string | number) => void;
}

export const Selector: FC<IComponentProps> = ({
  suffix,
  placeholder,
  searchable,
  allowClear = true,
  options,
  value,
  onChange,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');

  const filteredOptions = filterSelectorOptions(options, search);

  const generateClassName = () => {
    let className = 'selector';

    if (value) {
      className += ' selector__with-value';
    }

    return className;
  };

  const onDropdownVisibleChange = (open: boolean) => {
    setSearch('');
    setOpen(open);
  };

  const onSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clearSelection = () => {
    onChange?.(undefined);
    setOpen(false);
  };

  return (
    <Select
      className={generateClassName()}
      popupClassName="selector__popup"
      suffixIcon={<Control style={{ transform: `rotate(${open ? '-90' : '90'}deg)` }} />}
      menuItemSelectedIcon={<Check className="icon-purple" />}
      popupMatchSelectWidth={false}
      listHeight={160}
      virtual={false}
      open={open}
      onDropdownVisibleChange={onDropdownVisibleChange}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      notFoundContent={<ItemsNotFound />}
      labelRender={(props) => {
        return (
          <div className="selector__selection-item">
            {suffix}
            <span>{props.label}</span>
          </div>
        );
      }}
      dropdownRender={(menu) => {
        return (
          <>
            {searchable && (
              <Input
                className="selector__search"
                placeholder="Search"
                suffix={search ? undefined : <Search className="icon-gray" />}
                allowClear={{ clearIcon: <Close className="icon-gray" /> }}
                value={search}
                onChange={onSearchChange}
              />
            )}
            {menu}
            {allowClear && value && (
              <div className="selector__footer">
                <Button className="selector__clear-option" onClick={clearSelection}>
                  Clear selection
                </Button>
              </div>
            )}
          </>
        );
      }}
      options={filteredOptions}
    />
  );
};
